import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '../../../components/ui/Button';

const QuickActions = ({ onSaveProgress, onExportContent, className = '' }) => {
  const navigate = useNavigate();

  const actions = [
    {
      id: 'save',
      label: 'Save Progress',
      icon: 'Save',
      variant: 'outline',
      onClick: onSaveProgress
    },
    {
      id: 'export',
      label: 'Export Content',
      icon: 'Download',
      variant: 'outline',
      onClick: onExportContent
    },
    {
      id: 'dashboard',
      label: 'Back to Dashboard',
      icon: 'LayoutDashboard',
      variant: 'ghost',
      onClick: () => navigate('/user-dashboard')
    }
  ];

  return (
    <div className={`space-y-2 ${className}`}>
      <h3 className="text-sm font-heading font-semibold text-foreground mb-3">
        Quick Actions
      </h3>
      {actions?.map((action) => (
        <Button
          key={action?.id}
          variant={action?.variant}
          size="sm"
          fullWidth
          iconName={action?.icon}
          iconPosition="left"
          onClick={action?.onClick}
        >
          {action?.label}
        </Button>
      ))}
    </div>
  );
};

export default QuickActions;